import formatData from "./dataFormat";
import { DATE_FORMATE_MAP } from "./contant";
import dateTimeFormat, { CUSTOM_FORMAT_MAP } from "./dateTimeFormat";
import type { IFormatDataParams } from "./_type";


// 数据格式化和日期格式化函数处理函数
const dataCommonFormat = (params: IFormatDataParams) => {
  const { value, formatRule, emptyValue } = params || {};
  const isDateType = typeof formatRule === 'string' && (CUSTOM_FORMAT_MAP?.[formatRule] || DATE_FORMATE_MAP?.[formatRule]);
  // 日期处理函数入参value和formatRule 类型只能是string
  if( typeof value === 'string' && isDateType) {
    return dateTimeFormat( value, formatRule, emptyValue );
  }
  return formatData(params);
};

export default dataCommonFormat;